/**
 * File: src/containers/styled/Theme.js
 * Styled Theme
 */
export const Theme = {
  colors: {
    primary: '#1976D2',
    font_dark: '#212121',
    font_light: '#1C1B1F',
    white: '#FFFFFF',
    icon_gray: '#B9BCBE',
    button_gray: '#E0E0E0',
    background: '#F5F6FA',
    error: '#B00020',
    black: '#000000',
    red: '#880808'
  },
  border: {
    gray: '#CED0D4',
    divider: '#D9D9D9'
  },
  font: {
    family: "'Inter', helvetica, arial, sans-serif",
    size: '16px',
    sizes: {
      xxs: '0.65rem',
      xs: '0.75rem',
      s: '0.87rem',
      standard: '1rem',
      m: '1.25rem',
      l: '1.5rem',
      xl: '1.75rem',
      xxl: '2rem',
      xxxl: '3rem',
      xxxxl: '4rem'
    },
    weights: {
      light: '300',
      regular: '400',
      medium: '500',
      semi_bold: '600',
      bold: '700'
    }
  },
  radius: {
    sizes: {
      standard: '4px',
      m: '6px',
      l: '8px',
      xl: '10px',
      xxl: '12px',
      custom: '20px'
    }
  },
  sizes: {
    sidemenu: '180px'
  },
  shadow: {
    standard:
      '0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%)'
  }
};
